import queryString from 'query-string';
import SearchInputService from './SearchInputService';
import type { SearchURLPartsType } from '../../../../shared/model/transformers/srpSearchConditionUrlGenerator';
import {
  generateSearchUrl,
  locationUrlGenerator,
} from '../../../../shared/model/transformers/srpSearchConditionUrlGenerator';
import {
  convertCustomerPropertyTypesToQueryString,
  validatedAgencyChannel,
} from './queryGenerator';
import type {
  LocationDisplayType,
  RefinementsType,
} from '../../../../shared/model/constants/filterTypes';
import type { Location } from '../../../../shared/model/tsTypes';
import { stripUndefinedProperties } from '../../../../shared/stripUndefinedProperties';
import { parseConfig } from '../../../../shared/config';

const getLocationDisplayValues = (locations?: LocationDisplayType[]): string[] | undefined =>
  locations?.map((location) => location.displayValue);

const mapLocalitiesToLocations = (localities?: Location[]): LocationDisplayType[] | undefined =>
  localities?.map(({ locality, subdivision, postcode }) => ({
    displayValue: [locality, subdivision, postcode].filter(Boolean).join(' '),
  }));

export const urlFromRefinements = (refinements: RefinementsType): SearchURLPartsType => {
  const { localities, tenureTypeObject, channelObject } = refinements;
  const channelUrl = channelObject?.url;

  return generateSearchUrl({
    ...refinements,
    channelUrl,
    tenureTypeUrl: SearchInputService.showTenureTypeByChannel(channelUrl)
      ? tenureTypeObject?.url
      : undefined,
    locations: mapLocalitiesToLocations(localities),
  });
};

export const agencyUrlFromRefinements = (refinements: RefinementsType) => {
  const { localities, channelObject, propertyTypes, minPrice, maxPrice } = refinements;
  const locations = getLocationDisplayValues(mapLocalitiesToLocations(localities));
  const locationInPath = locationUrlGenerator(locations);
  const queryObject = {
    minPrice: minPrice || undefined,
    maxPrice: maxPrice || undefined,
    propertyTypes: convertCustomerPropertyTypesToQueryString(propertyTypes),
    channel: validatedAgencyChannel(channelObject.url),
  };
  const search = queryString.stringify(stripUndefinedProperties(queryObject));
  const { WEBSITE_ROOT } = parseConfig() as unknown as { WEBSITE_ROOT: string };

  return {
    pathname: `${WEBSITE_ROOT}/find-agency/${locationInPath}/`,
    search: search.toLowerCase(),
  };
};
